export default "__VITE_ASSET__CczH8lum__"